// import ButtonArrow from "../reusable/ButtonArrow";

// export default function ContactUsHome() {
//   return (
//     <section className="relative h-[30vh] md:h-[30vh] w-full bg-gradient-to-b from-white to-gray-200">
//       <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
//         <h1 className="text-4xl sm:text-6xl  text-black">
//           How can we help you?
//           {/* Careers */}
//         </h1>
//         <ButtonArrow 
//           txt="Contact us"
//           link="/contact-us"
//           style="w-[170px] text-black hover:no-underline text-lg font-medium"
//           className="text-center"
//         />
//       </div>
//     </section>
//   );
// }

// import Link from "next/link";

// export default function ContactUsHome() {
//     return (
//       <div className="w-full bg-gradient-to-t from-amber-50 to-white ">
//         <div className="max-w-3xl mx-auto px-4 text-center">
//           <h2 className="text-3xl font-bold text-gray-800 mb-4">
//             Ready to Transform Your Business?
//           </h2>
          
//           <p className="text-lg text-gray-600 mb-8">
//           Join industry leaders who've already discovered how our solutions can drive growth. Our team is ready to create your custom solution to give you a competitive edge.
//           </p>
          
//           <div className="mb-8">
//             <a 
//               href="/contact-us"
//               className="inline-block group relative overflow-hidden rounded-lg bg-amber-600 px-8 py-4 text-white transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
//             >
//               <span className="relative z-10 text-lg font-semibold">
//               Schedule Your Consultation
//               </span>
//               <div className="absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
//             </a>
//           </div>
//         </div>
//       </div>
//     )
//   }
  

import Link from "next/link";

export default function ContactUsHome() {
    return (
        <div className="w-full bg-gradient-to-t from-amber-50 to-white mt-8">
            <div className="max-w-3xl mx-auto pb-7 px-4 text-center">
                <h2 className="text-3xl font-bold text-gray-800 mb-4">
                    Ready to Transform Your Business?
                </h2>

                <p className="text-lg text-gray-600 mb-8">
                    Join industry leaders already scaling with our{" "}
                    <Link href="/services/custom-software-development">
                        <a className="text-amber-700 font-medium hover:underline">custom software solutions</a>
                    </Link>. Let’s build the tools your business needs to grow faster and stay ahead.
                </p>

                <div className="py-5">
                    <Link href="/contact-us">
                        <a className="inline-block group relative overflow-hidden rounded-lg bg-amber-600 px-8 py-4 text-white transform transition-all duration-300 hover:scale-105 hover:shadow-xl">
                            <span className="relative z-10 text-lg font-semibold">
                                Schedule Your Consultation
                            </span>
                            <div className="absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
                        </a>
                    </Link>
                </div>
            </div>
        </div>
    );
}
